var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom-loader"},[_c('img',{attrs:{"src":require(`@/assets/media/videos/loader.gif`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }